import { Outlet } from 'react-router-dom'
import { Sidebar } from './sidebar'
import { Header } from './header'
import { HelpChatWidget } from '@/components/chat/help-chat-widget'
import { ImpersonationBanner } from '@/components/shared/impersonation-banner'
import { useUIStore } from '@/store/ui-store'
import { useAuthStore } from '@/store/auth-store'
import { useNotificationPoller } from '@/hooks/useNotificationPoller'
import { cn } from '@/lib/utils'

export function AppLayout() {
  const { sidebarCollapsed } = useUIStore()
  const isImpersonating = useAuthStore((s) => s.isImpersonating)
  useNotificationPoller()

  return (
    <div className="min-h-screen bg-background">
      {isImpersonating && <ImpersonationBanner />}
      <Sidebar />
      <div
        className={cn(
          'flex flex-col transition-all duration-300',
          sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64',
          isImpersonating ? 'pt-10' : ''
        )}
      >
        <Header />
        <main className="flex-1" style={{ padding: '24px' }}>
          <Outlet />
        </main>
      </div>
      {/* Every authenticated page. Public routes render outside AppLayout. */}
      <HelpChatWidget />
    </div>
  )
}
